import axios from 'axios';
import { whenRequestWithError, whenResponseWithError } from './interceptors';
const fetcher = axios.create();
fetcher.interceptors.request.use((config) => config, whenRequestWithError);
fetcher.interceptors.response.use((response) => response, whenResponseWithError);
export { fetcher };
